"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@opensea/graphql";
import { useAccount } from "@opensea/wallet";
import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";
import { DropStatus } from "@/components/collection/drops/constants";
import { dropEligibilityQuery } from "../../drop-store";
import { useDropStore } from "./use-drop-store";
export function useDropEligibility(collectionSlug) {
  const $ = _c(48);
  const {
    address
  } = useAccount();
  const t0 = address ?? "";
  let t1;
  if ($[0] !== collectionSlug || $[1] !== t0) {
    t1 = {
      collectionSlug,
      address: t0
    };
    $[0] = collectionSlug;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = !address;
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = {
      query: dropEligibilityQuery,
      variables: t1,
      pause: t2
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const [t4, refetch] = useQuery(t3);
  const {
    data,
    fetching
  } = t4;
  const [status, activeStageIndex, quantityMinted, is1155Drop, setQuantityMinted, setEligibilityData, setIsLoadingEligibility, setRefetchEligibility, updateStageEligibility] = useDropStore(useShallow(_temp));
  const minterQuantityMinted = data?.dropBySlug?.__typename === "Erc721SeaDropV1" ? data.dropBySlug.minterQuantityMinted ?? 0 : 0;
  let t5;
  if ($[6] !== activeStageIndex || $[7] !== data?.dropBySlug?.stages) {
    t5 = data?.dropBySlug?.stages.find(stage => stage.stageIndex === activeStageIndex);
    $[6] = activeStageIndex;
    $[7] = data?.dropBySlug?.stages;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const activeStage = t5;
  let t6;
  let t7;
  if ($[9] !== minterQuantityMinted || $[10] !== setQuantityMinted) {
    t6 = () => {
      setQuantityMinted(minterQuantityMinted);
    };
    t7 = [setQuantityMinted, minterQuantityMinted];
    $[9] = minterQuantityMinted;
    $[10] = setQuantityMinted;
    $[11] = t6;
    $[12] = t7;
  } else {
    t6 = $[11];
    t7 = $[12];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[13] !== fetching || $[14] !== setIsLoadingEligibility) {
    t8 = () => {
      setIsLoadingEligibility(fetching);
    };
    t9 = [setIsLoadingEligibility, fetching];
    $[13] = fetching;
    $[14] = setIsLoadingEligibility;
    $[15] = t8;
    $[16] = t9;
  } else {
    t8 = $[15];
    t9 = $[16];
  }
  useEffect(t8, t9);
  let t10;
  let t11;
  if ($[17] !== refetch || $[18] !== setRefetchEligibility) {
    t10 = () => {
      setRefetchEligibility(refetch);
    };
    t11 = [setRefetchEligibility, refetch];
    $[17] = refetch;
    $[18] = setRefetchEligibility;
    $[19] = t10;
    $[20] = t11;
  } else {
    t10 = $[19];
    t11 = $[20];
  }
  useEffect(t10, t11);
  let t12;
  if ($[21] !== address || $[22] !== data || $[23] !== updateStageEligibility) {
    t12 = () => {
      if (!(address && data?.dropBySlug?.stages)) {
        return;
      }
      const eligibilityStageData = data.dropBySlug.stages.map(_temp2);
      updateStageEligibility(eligibilityStageData);
    };
    $[21] = address;
    $[22] = data;
    $[23] = updateStageEligibility;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  const t13 = data?.dropBySlug?.stages;
  let t14;
  if ($[25] !== address || $[26] !== is1155Drop || $[27] !== t13 || $[28] !== updateStageEligibility) {
    t14 = [address, t13, is1155Drop, updateStageEligibility];
    $[25] = address;
    $[26] = is1155Drop;
    $[27] = t13;
    $[28] = updateStageEligibility;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  useEffect(t12, t14);
  let t15;
  if ($[30] !== activeStage?.eligibleMaxTotalMintableByWallet || $[31] !== activeStage?.eligiblePrice || $[32] !== activeStage?.isEligible || $[33] !== activeStage?.maxTotalMintableByWallet || $[34] !== activeStage?.stageType || $[35] !== address || $[36] !== data?.dropBySlug?.stages || $[37] !== quantityMinted || $[38] !== setEligibilityData || $[39] !== status) {
    t15 = () => {
      if (!address) {
        setEligibilityData({
          isEligibleForCurrentStage: undefined,
          maxMints: undefined,
          eligibleStageIndices: [],
          eligiblePrice: null
        });
        return;
      }
      const maxStageMints = activeStage?.eligibleMaxTotalMintableByWallet ?? activeStage?.maxTotalMintableByWallet ?? 0;
      const eligibleStageIndices = data?.dropBySlug?.stages.flatMap(_temp3) ?? [];
      setEligibilityData({
        isEligibleForCurrentStage: Boolean(activeStage?.stageType === "PUBLIC_SALE" || activeStage?.isEligible),
        maxMints: status === DropStatus.MINTED_OUT ? 0 : maxStageMints - quantityMinted,
        eligibleStageIndices,
        eligiblePrice: activeStage?.eligiblePrice ?? null
      });
    };
    $[30] = activeStage?.eligibleMaxTotalMintableByWallet;
    $[31] = activeStage?.eligiblePrice;
    $[32] = activeStage?.isEligible;
    $[33] = activeStage?.maxTotalMintableByWallet;
    $[34] = activeStage?.stageType;
    $[35] = address;
    $[36] = data?.dropBySlug?.stages;
    $[37] = quantityMinted;
    $[38] = setEligibilityData;
    $[39] = status;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  const t16 = data?.dropBySlug?.stages;
  let t17;
  if ($[41] !== activeStage || $[42] !== address || $[43] !== quantityMinted || $[44] !== setEligibilityData || $[45] !== status || $[46] !== t16) {
    t17 = [address, activeStage, t16, quantityMinted, status, setEligibilityData];
    $[41] = activeStage;
    $[42] = address;
    $[43] = quantityMinted;
    $[44] = setEligibilityData;
    $[45] = status;
    $[46] = t16;
    $[47] = t17;
  } else {
    t17 = $[47];
  }
  useEffect(t15, t17);
}
function _temp3(stage_1) {
  return stage_1.isEligible ? [stage_1.stageIndex] : [];
}
function _temp2(stage_0) {
  return {
    stageIndex: stage_0.stageIndex,
    stageType: stage_0.stageType,
    isEligible: stage_0.isEligible ?? false,
    eligiblePrice: stage_0.eligiblePrice ?? undefined,
    eligibleMaxTotalMintableByWallet: stage_0.eligibleMaxTotalMintableByWallet ?? 0,
    eligibleMaxTotalMintableByWalletPerToken: stage_0.__typename === "Erc1155SeaDropV2Stage" ? stage_0.eligibleMaxTotalMintableByWalletPerToken ?? stage_0.eligibleMaxTotalMintableByWallet ?? undefined : undefined,
    fromTokenId: stage_0.__typename === "Erc1155SeaDropV2Stage" ? Number(stage_0.fromTokenId) : undefined,
    toTokenId: stage_0.__typename === "Erc1155SeaDropV2Stage" ? Number(stage_0.toTokenId) : undefined
  };
}
function _temp(state) {
  return [state.status, state.activeStageIndex, state.quantityMinted, state.is1155Drop, state.setQuantityMinted, state.setEligibilityData, state.setIsLoadingEligibility, state.setRefetchEligibility, state.updateStageEligibility];
}